import { escapeSpecialChars } from 'src/lib/regex';

const blogTranslations = [
  'blog', // English, Spanish, etc.
  'блог', // Russian, Bulgarian
  'blogg', // Swedish
  'blogi', // Finnish
  'مدونة', // Arabic
  'وبلاگ', // Persian
  'בלוג', // Hebrew
  'ब्लॉग', // Hindi
  'ব্লগ', // Bengali
  'μπλογκ', // Greek
  '博客', // Chinese
  'ブログ', // Japanese
  '블로그', // Korean
  'บล็อก', // Thai
];

// Create a simple regex to match anywhere in the text (case-insensitive)
const blogPattern = new RegExp(blogTranslations.map(escapeSpecialChars).join('|'), 'i');

export const containsBlog = (text) => blogPattern.test(text);
